import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'

// GET /curriculums/search?q=search&by=code
export const searchCurriculum = (search) => {
  const request = get('/curriculums/search', {q: search, by: 'code'})
  request.types = ['CURR_Q_REQ', 'CURR_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Curriculums/actions.js